import * as React from "react"
const SvgNumber = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9 16-.825 3.275A.915.915 0 0 1 7.25 20a.95.95 0 0 1-.775-.375.88.88 0 0 1-.175-.825L7 16H4.275a.96.96 0 0 1-.8-.387.95.95 0 0 1-.175-.863.88.88 0 0 1 .35-.55q.275-.2.625-.2H7.5l1-4H5.775a.96.96 0 0 1-.8-.387.95.95 0 0 1-.175-.863.88.88 0 0 1 .35-.55q.275-.2.625-.2H9l.825-3.275A.915.915 0 0 1 10.75 4q.475 0 .775.375t.175.825L11 8h4l.825-3.275A.915.915 0 0 1 16.75 4q.475 0 .775.375t.175.825L17 8h2.725q.5 0 .8.388.3.387.175.862a.88.88 0 0 1-.35.55q-.275.2-.625.2H16.5l-1 4h2.725q.5 0 .8.387.3.388.175.863a.88.88 0 0 1-.35.55q-.275.2-.625.2H15l-.825 3.275a.915.915 0 0 1-.925.725.95.95 0 0 1-.775-.375.88.88 0 0 1-.175-.825L13 16zm.5-2h4l1-4h-4z" />
  </svg>
)
export default SvgNumber
